<template>
  <div class="pb-3">
    <organism-customer-detail v-if="!isLoading" :customer="customer" />
  </div>
</template>

<script>
import OrganismCustomerDetail from "@/components/organisms/portal/external/OrganismCustomerDetail.vue"
import { getExternalContractsById } from "@/api/api-module1"
import mixins from "@/mixins"
import mixinsDateTime from "@/mixins/mixinsDatetime"
import mixinsValidator from "@/mixins/mixinsValidator"

export default {
  name: "CustomerDetail",
  components: { OrganismCustomerDetail },
  mixins: [mixins, mixinsDateTime, mixinsValidator],
  data() {
    return {
      isLoading: true,

      customer: {
        idcId: "",
        name: "",
        site: "",
        startDate: "",
        services: [
          {
            service: "",
            package: "",
            contractPeriod: "",
            location: "",
            bundleNetwork: null,
            domain: null,
            rack: [],
            note: "",
            standardService: [],
            options: [],
          },
        ],
        technicalInformation: {
          ipAddress: [],
          detail: "",
        },
        saleContact: {
          name: "",
          email: "",
          phone: "",
          imgUrl: null,
        },
      },
    }
  },
  mounted() {
    this.getCustomerDetail()
  },
  methods: {
    async getCustomerDetail() {
      this.showLoading(true)

      await getExternalContractsById()
        .then((response) => {
          this.customer = {
            idcId: response.contractId.toString().padStart(8, "0"),
            name: response.customerName,
            siteName: this.toPascalCase(response.siteName),
            startDate: this.setDateTimeFormat(
              response.startDate,
              "dd/MM/yyyy HH:mm"
            ),
            services: response.services.map((item) => {
              return {
                service: item.service,
                startDate: this.setDateTimeFormat(
                  item.startDate,
                  "dd/MM/yyyy HH:mm"
                ),
                package: item.package,
                packageQuantity: item.packageQuantity,
                contractPeriod: item.packagePeriod,
                location: item.locationName,
                bundleNetwork: item.bundleNetwork,
                domain: item.domain,
                rack: item?.oceanRacks,
                note: item.serviceNote,
                serviceInformation: item.serviceInformation,
                options: item.contractPackageOption.map((option) => ({
                  option: option.optionName,
                  quantity: option.quantity,
                })),
              }
            }),
            technicalInformation: {
              ipAddress: response.ipAddresses,
              detail: response.otherTechnicalDetail,
            },
            saleContact: {
              name: `${response.saleContact.contactFirstname} ${response.saleContact.contactLastname}`,
              email: response.saleContact.contactEmail,
              phone: response.saleContact.contactPhone,
              imgUrl: response.saleContact.contactImage,
            },
          }
        })
        .finally(() => {
          this.isLoading = false
          this.showLoading(false)
        })
    },

    toPascalCase(words) {
      return words.replace(/\w+/g, function (w) {
        return w[0].toUpperCase() + w.slice(1).toLowerCase()
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
